import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqItems = [
  {
    question: 'Will you sign an NDA?',
    answer: 'Yes, before any sensitive information is shared.',
  },
  {
    question: 'Do you replace staff?',
    answer: 'No. The team is the business. We value continuity.',
  },
  {
    question: 'What size businesses?',
    answer: '£500k–£5m turnover, though we are flexible.',
  },
  {
    question: 'Do you use earnouts?',
    answer: 'We prefer clean exits but can structure flexibly.',
  },
  {
    question: 'How long does it take?',
    answer: 'Typically 6–12 weeks from agreement to completion.',
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section 
      id="faq" 
      className="py-16 px-6 bg-section-alt"
      data-testid="faq-section"
    >
      <div className="max-w-3xl mx-auto">
        <h2 className="text-[2rem] md:text-[2.5rem] font-bold text-[#1a1a1a] mb-8 tracking-tight">
          Frequently Asked Questions
        </h2>

        <div className="faq-container">
          {faqItems.map((item, index) => (
            <div key={index} className="faq-item" data-testid={`faq-item-${index}`}>
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-5 py-4 flex items-center justify-between text-left hover:bg-[#faf9f7] transition-colors"
              >
                <span className="font-semibold text-[#1a1a1a] text-sm">{item.question}</span>
                <ChevronDown className={`w-4 h-4 text-[#5a5a5a] transition-transform ${openIndex === index ? 'rotate-180' : ''}`} />
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-[#5a5a5a] text-sm">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
